import BaseAsideEntitySetupService from '@/setup/BaseAsideEntitySetupService';
import OrganizationUserEntity from '@/entity/organization-user/OrganizationUserEntity';
import OrganizationUserApi from '@/api/OrganizationUserApi';
import { USER_TYPE } from '@/typings/enums/USER_TYPE';
import { PropType, watch } from 'vue';
import UserClientEntity from '@/entity/user-client/UserClientEntity';
import UserApiAgency from '@/api/UserApiAgency';
import { fakeUser } from '@/utils/tools';
import { itemIs, usePopableQueue } from '@orion.ui/orion';
import useRouterHistoryService from '@/services/RouterHistoryService';
import { SUITE_URL } from '@/utils/CONST';

type Props = SetupProps<typeof OrganizationUserAsideDetailsSetupService.props>

export default class OrganizationUserAsideDetailsSetupService extends BaseAsideEntitySetupService<Props, IOrganizationUserDetailModel> {
	static readonly props = {
		readonly: Boolean,
		self: Boolean,
		id: {
			type: Number,
			default: undefined,
		},
		userType: {
			type: Number as PropType<USER_TYPE>,
			default: undefined,
		},
		fake: Boolean,
	};

	protected get api () {
		if (this.route.path.includes('mes-client') && !this.props.self) {
			return { getDetailed: (id: number) => UserApiAgency.getDetailedClient(id) };
		} else {
			return OrganizationUserApi;
		}
	}

	get suiteUserId () {
		if (itemIs<OrganizationUserEntity>(this.entity, 'suiteUserId'))
			return this.entity.suiteUserId;
	}

	isOrganizationUserEntity () : this is { organizationUser: OrganizationUserEntity } {
		return itemIs<OrganizationUserEntity>(this.entity, 'suiteUserId');
	}

	protected readonly entity = (this.route.path.includes('mes-client') && !this.props.self)
		? new UserClientEntity()
		: new OrganizationUserEntity();

	private _aside?: OrionAside;

	get organizationUser () { return this.entity; };
	get userIsAgencyWatchingClient (): boolean {
		return this.props.userType === USER_TYPE.Client && this.self.isAgency()
		|| (this.route.path.includes('mes-clients') && !this.props.self);
	}


	constructor (props: Props, _aside?: OrionAside) {
		super(props);
		this._aside = _aside;
		this.state.activeTab = 'permissions';
		if (this.props.fake) {
			this.entity.assignData(fakeUser);
		}
	}

	protected async onBeforeMountAsync (): Promise<void> {
		if (!this.props.fake) super.onBeforeMountAsync();
	}

	protected onMounted () {
		watch(() => this.entity.userId, () => {
			if (this.entity.userId && !this.props.fake) {
				this.registerBusEvent(`${this.entity.userId}:addUserRole`, () => this.getDetailsAsync());
				this.registerBusEvent(`${this.entity.userId}:deleteUserRole`, () => this.getDetailsAsync());
			}
		});

		this._aside?.open();
		this._aside?.bus.on('leave-end', () => {
			setTimeout(() => {
				/**
         * Si l'asideQueue n'est pas vide,
         * cela signifie qu'on a ouvert l'aside de création de rôle,
         * dans ce cas on ne redirige pas
				 * ou si l'aside est ouverte depuis le recap rôles & permission de la navigation
         */
				if (!usePopableQueue().asideQueue.length && !this.props.self) {
					if ((this.route.name === 'OrganizationUserDetails' && useRouterHistoryService().previousRoute?.name === 'OrganizationUser')
            || (this.route.name === 'UserDetails' && useRouterHistoryService().previousRoute?.name === 'User')
					) {
						this.router.push(useRouterHistoryService().previousRoute);
					} else {
						this.route.name === 'OrganizationUserDetails'
							? this.router.push({ name: 'OrganizationUser' })
							: this.router.push({ name: 'User' });
					}
				}
			}, 100);
		});
	}

	protected onUnmounted () {
		this._aside?.close();
		this._aside?.bus.off('leave-end');
	}

	goToSuiteUser () {
		if (this.itemHas(this.organizationUser, 'suiteUserId'))
			window.location.href = SUITE_URL + `/utilisateurs/${this.organizationUser.suiteUserId}/general?&source=Armado&sourceUrl=${location.href}`;
	}
}
